import Navbar from '../../components/layout/Navbar';
import RegistroDatos from '../../components/sections/RegistroDatos';
import Footer from '../../components/layout/Footer';

export default function RegistroPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="registro" />

      <main className="pt-16">
        <RegistroDatos />
      </main>

      <Footer />
    </div>
  );
}